import { connect } from 'react-redux';
import type { MapDispatchToProps, MapStateToProps } from 'react-redux';
import { submit, formValueSelector } from 'redux-form';
import type { FormStateMap } from 'redux-form';
import { travelerForm } from '@eti/travelers';
import type { Dispatch, SetStateAction } from 'react';
import { CONTACT_INFO_FORM_SECTION, contactFields } from '../../constants/formFields';
import { type Country, type Traveler } from '../../models';
import type { FormNamesType } from '../../../../utils/dynamicBookingFlow';
import InfoReviewModal from './InfoReviewModal';

const { EMAIL, PHONE, PHONE_COUNTRY_ID } = contactFields;

interface State {
  form: FormStateMap;
}

interface ConnectedStateProps {
  contactInfo: { email: string; phone: string; phoneCountry: number };
}

interface ConnectedDispatchProps {
  submitForm: () => void;
}

interface OwnProps {
  countries: Country[];
  handleEditInfo: (scrollTo?: string) => void;
  isOpen: boolean;
  setShowInfoReviewModal: Dispatch<SetStateAction<boolean>>;
  travelers: Traveler[];
}

const transformTravelers = (formArg: FormNamesType, stateArg: State, travelersArg: Traveler[]) => {
  return travelersArg.map((traveler, index) => {
    const { ageType } = traveler;
    const firstName = travelerForm.getSelectedFirstName(formArg)(stateArg, index);
    const lastName = travelerForm.getSelectedLastName(formArg)(stateArg, index);

    return {
      ageType,
      firstName,
      lastName,
    };
  });
};

const mapStateToProps: MapStateToProps<
  ConnectedStateProps,
  OwnProps & { form: FormNamesType },
  State
> = (state, { form, travelers }) => {
  const getFormValue = formValueSelector(form);
  const email = getFormValue(state, `${CONTACT_INFO_FORM_SECTION}.${EMAIL}`);
  const phone = getFormValue(state, `${CONTACT_INFO_FORM_SECTION}.${PHONE}`);
  const phoneCountry = getFormValue(state, `${CONTACT_INFO_FORM_SECTION}.${PHONE_COUNTRY_ID}`);

  return {
    travelers: transformTravelers(form, state, travelers),
    contactInfo: { email, phone, phoneCountry },
  };
};

const mapDispatchToProps: MapDispatchToProps<
  ConnectedDispatchProps,
  OwnProps & { form: FormNamesType }
> = (dispatch, { form }) => ({
  submitForm() {
    dispatch(submit(form));
  },
});

const InfoReviewModalContainer = ({
  contactInfo,
  countries,
  submitForm,
  handleEditInfo,
  isOpen,
  setShowInfoReviewModal,
  travelers,
}: OwnProps & ConnectedStateProps & ConnectedDispatchProps) => {
  return (
    <InfoReviewModal
      contactInfo={contactInfo}
      countries={countries}
      handleEditInfo={handleEditInfo}
      isOpen={isOpen}
      onSubmit={submitForm}
      setShowInfoReviewModal={setShowInfoReviewModal}
      travelers={travelers}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoReviewModalContainer);
